import { DollyIcon } from './DollyIcon';

/**
 * author: Michael Irigoyen
 * id 6F2EAC1C-802A-48CF-A9E1-7EBFD4893BAF
 * name dolly
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dolly.svg
 * tags
 */
export const HandTruckIcon = DollyIcon;
export default HandTruckIcon